import React from "react"
import { OutboundLink } from "gatsby-plugin-google-gtag"

export default class StockTwitsFeed extends React.Component {
    state ={
      feedVisible: false
    }

    render() {
        return (
            <div id="stocktwitsfeedcontainer" style={{visibility:(this.state.feedVisible)?'visible':'hidden'}}>
                <div id="stocktwits-widget-news"></div>
                <OutboundLink href='https://stocktwits.com' style={{fontSize:"0px"}}>Stocktwits</OutboundLink>
            </div>
        )
    }
    removeFeed() {
        const oldFeed = document.getElementById("stocktwits-widget-news")
        oldFeed.innerHTML=""
    }
    refreshFeed() {
        this.removeFeed()
        if (this.props.ticker === "") { //hide component if we don't have a ticker
            this.setState({feedVisible:false}) 
            return;
        } 
        const twitsscript = document.createElement('script')
        this.twitparams.symbol=this.props.ticker
        this.twitparams.title=""
        twitsscript.innerHTML = " STWT.Widget("+JSON.stringify(this.twitparams)+");"
        document.getElementById("stocktwitsfeedcontainer").appendChild(twitsscript)
        this.setState({feedVisible:true}) 
    }
  
    componentDidUpdate(prevProps) {
        if (prevProps.ticker !== this.props.ticker) { //ticker has changed
                this.refreshFeed();
        }
    }

    componentDidMount(){
        const script = document.createElement('script')
        script.src = "https://api.stocktwits.com/addon/widget/2/widget-loader.min.js"
        document.getElementById("stocktwitsfeedcontainer").appendChild(script)

        script.onload = () => { //once the stocktwits JS has loaded, instantiate the feed (if we've got a ticker)
            this.refreshFeed();
        }
    }
    twitparams =   {
        container: 'stocktwits-widget-news',
         symbol: 'AAPL',
          width: '340', height: '600', limit: '25', scrollbars: 'true',
           streaming: 'true',
            title: 'AAPL Ideas', 
    style: {link_color: '4871a8', link_hover_color: '4871a8', header_text_color: '000000', border_color: 'cecece', divider_color: 'cecece', divider_type: 'solid', box_color: 'f5f5f5', stream_color: 'ffffff', text_color: '000000', time_color: '999999'}}

  }



